import type { SxProps, Theme } from '@mui/material/styles';

export const formAutocompleteFieldStyles = {
	root: (readonly: boolean, canAddNewItem?: boolean, hideLabel?: boolean) => ({
		width: '100%',
		display: 'grid',
		gridTemplateColumns:
			readonly || hideLabel
				? '1fr'
				: {
						xs: '1fr',
						sm: 'min-content 1fr'
					},
		alignItems: canAddNewItem ? 'flex-start' : 'center',
		gap: 1
	}),

	label: {
		pt: 1,
		height: '100%',
		minWidth: 200,
		typography: 'subtitle1',
		color: 'text.primary',
		userSelect: 'none',
		fontWeight: '700',
		pointerEvents: 'none'
	},

	fieldWrap: {
		gridTemplateColumns: {
			xs: '1fr min-content'
		},
		display: 'grid',
		position: 'relative',
		width: '100%'
	},

	caption: {
		mt: 0.5,
		color: 'text.secondary',
		fontSize: '0.875rem'
	},

	field: {
		position: 'relative'
	},

	fieldControls: {
		display: 'flex',
		alignItems: 'center',
		gap: 1.5,
		ml: 1
	},

	addNewItemButtonWrap: {
		display: 'flex',
		justifyContent: 'flex-start',
		alignItems: 'center',
		width: 'fit-content',
		marginTop: 1
	},

	removeButton: (isReadOnly: boolean) =>
		({
			opacity: isReadOnly ? 0 : 1,
			visibility: isReadOnly ? 'hidden' : 'visible',
			pointerEvents: isReadOnly ? 'none' : 'auto'
		}) as SxProps<Theme>
};
